module.exports = __webpack_public_path__ + "img/chat.1c3c5500.svg";